import { Component } from '@angular/core';

@Component({
    moduleId: module.id,
    styleUrls: ['./chalukat-matanot.component.css'],
    template: `<section class="section" id="planAndDev">  
                <div class="bContainer container">  
                  <div class="row navHeader clearfix">
                     <div class="col-md-pull-1 col-md-10" id="" role="main">
                     <router-outlet></router-outlet>
                    </div>
                    </div>
                </div>
                </section>
                `

})

export class HomeChalukatComponent {

}